import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { Store } from '../../redux/Store';
import { Link } from 'react-router-dom';

import './Home.css';

class Home extends Component {
    constructor(props) {
        super(props)
        this.state = {
            body_class: ['apps-gotlocked-order', 'apps-gotlocked-video-banner', 'apps-gotlocked-homepage', 'apps-gotlocked-home']
        }
    }
    
    componentWillMount() {
        setTimeout(function() {
            if (document.body.classNameList) {
                document.body.classNameList.add(...this.state.body_class);
            } else {
                document.body.className = this.state.body_class.join(' ');
            }
            //document.getElementById('apps-gotlocked-menu').style.display = 'none';
        }.bind(this), 1);
    }

    render() {
        return (
            <div>
                <section className="apps-gotlocked-welcome-section apps-gotlocked-video-bg" id="apps-gotlocked-home">
                    <div className="apps-gotlocked-welcome-container">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="apps-gotlocked-welcome-tbl">
                                        <div className="text-center">
                                            <div className="apps-gotlocked-welcome-content text-center">
                                                <h1>Get <span>5$ off</span> your first order</h1>
                                                <p>GOTLOCKED is a service that that brings the top trusted locksmiths in your area, to your door.</p>
                                                <p className="button-wrapper">
                                                    <Link to="/order" className="apps-gotlocked-btn app-store-btn website-btn"> Find a locksmith</Link>
                                                </p>
                                                <p className="button-wrapper">OR</p>
                                                <p className="button-wrapper2">
                                                    <Link to="/status" className="apps-gotlocked-btn app-store-btn website-btn-status">Check Order Status</Link>
                                                </p>
                                                <p className="button-wrapper2">
                                                    <Link to="/map" className="apps-gotlocked-btn app-store-btn website-btn-status">Map</Link>
                                                </p>
                                                <p className="button-wrapper2">
                                                    <Link to="/payment" className="apps-gotlocked-btn app-store-btn website-btn-status">Payment</Link>
                                                </p>
                                                <div className="apps-gotlocked-download-store-btn-group">
                                                    <Link to="" className="apps-gotlocked-btn play-store-btn"><img src="/img/google-play-logo.png" alt="" /></Link>
                                                    <Link to="" className="apps-gotlocked-btn app-store-btn"><img src="/img/app-store-logo.png" alt="" /></Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default Home;